import type { LifecycleAdapter, SafeAreaInsets } from '../types';

export const webLifecycle: LifecycleAdapter = {
  onVisibilityChange(cb) {
    const handler = () => cb(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  },
  onResize(el, cb) {
    const ro = new ResizeObserver(entries => {
      for (const e of entries) cb(e.contentRect);
    });
    ro.observe(el);
    return () => ro.disconnect();
  },
  safeArea(): SafeAreaInsets {
    const s = getComputedStyle(document.documentElement);
    const v = (prop: string) => parseFloat(s.getPropertyValue(prop)) || 0;
    return {
      top:    v('env(safe-area-inset-top)'),
      right:  v('env(safe-area-inset-right)'),
      bottom: v('env(safe-area-inset-bottom)'),
      left:   v('env(safe-area-inset-left)'),
    };
  },
  prefersReducedMotion() {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  },
  setThemeColor(color) {
    document.body.style.background = color;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', color);
  },
};
